import type { ReactNode } from 'react';

export const symbol_metro: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M120-170v-601q0-29.05 20-49.03Q160-840 189.09-840H220q21.33 0 38.67 12Q276-816 284-796l196 513 194-509q8.12-21.74 27.06-34.87Q720-840 743.45-840H766q30.68 0 52.34 21.66Q840-796.68 840-766v596q0 20.83-14.62 35.42Q810.76-120 789.88-120q-20.88 0-35.38-14.58Q740-149.17 740-170v-509L535-148q-5 12-15.46 19.5T496-121h-32.26q-12.74 0-23.24-7.5Q430-136 425-148L220-675v505q0 20.83-14.62 35.42Q190.76-120 169.88-120q-20.88 0-35.38-14.58Q120-149.17 120-170Z"
		/>
	</svg>
);
